import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

import PanelHeader from '../common/cards/PanelHeader';
import actionsIcon from '../../images/icons/policy-actions.svg';
import requestProposalComparisonIcon from '../../images/icons/request-proposal-comparison.svg';
import requestPolicyDocumentIcon from '../../images/icons/request-policy-document.svg';
import requestEndorsementIcon from '../../images/icons/request-endorsements.svg';
import requestCancelIcon from '../../images/icons/request-cancel.svg';
import viewEndorsementsIcon from '../../images/icons/view-endorsement.svg';
import requestOtherIcon from '../../images/icons/icon-hub-menu-other-request.svg';
import viewDocumentsIcon from '../../images/icons/icon-hub-menu-view-documents.svg';
import rightArrowImg from '../../images/cheveron-right.svg';

import style from './ActionsPanel.module.css';

const ActionsPanel = React.memo(({ clientId, panelState }) => {
  return (
    <section className={style.main}>
      <PanelHeader icon={actionsIcon} title="POLICY ACTIONS" />
      <ul>
        {panelState.proposals && (
          <li>
            <Link to={`/clients/${clientId}/requests/proposal-comparison`}>
              <img
                className={style.icon}
                src={requestProposalComparisonIcon}
                alt="request proposal comparison"
              />
              <span>Request Proposal Comparison</span>
              <img className={style.arrow} src={rightArrowImg} alt="" />
            </Link>
          </li>
        )}
        <li>
          <Link to={`/clients/${clientId}/requests/policy-document`}>
            <img
              className={style.icon}
              src={requestPolicyDocumentIcon}
              alt="request policy document"
            />
            <span>Request Policy Document</span>
            <img className={style.arrow} src={rightArrowImg} alt="" />
          </Link>
        </li>
        <li>
          <Link to={`/clients/${clientId}/documents`}>
            <img
              className={style.icon}
              src={viewDocumentsIcon}
              alt="view documents"
            />
            <span>View Documents</span>
            <img className={style.arrow} src={rightArrowImg} alt="" />
          </Link>
        </li>
        {panelState.policies && (
          <>
            <li>
              <Link to={`/clients/${clientId}/requests/endorsement`}>
                <img
                  className={style.icon}
                  src={requestEndorsementIcon}
                  alt="request endorsement"
                />
                <span>Request Endorsement</span>
                <img className={style.arrow} src={rightArrowImg} alt="" />
              </Link>
            </li>
            <li>
              <Link to={`/clients/${clientId}/endrosements`}>
                <img
                  className={style.icon}
                  src={viewEndorsementsIcon}
                  alt="view endorsements"
                />
                <span>View Endorsement Requests</span>
                <img className={style.arrow} src={rightArrowImg} alt="" />
              </Link>
            </li>
            <li>
              <Link to={`/clients/${clientId}/requests/cancel`}>
                <img
                  className={style.icon}
                  src={requestCancelIcon}
                  alt="request cancel/erp"
                />
                <span>Request Cancel/ERP</span>
                <img className={style.arrow} src={rightArrowImg} alt="" />
              </Link>
            </li>
            <li>
              <Link to={`/clients/${clientId}/requests/other`}>
                <img
                  className={style.icon}
                  src={requestOtherIcon}
                  alt="other service request"
                />
                <span>Other Service Request</span>
                <img className={style.arrow} src={rightArrowImg} alt="" />
              </Link>
            </li>
          </>
        )}
      </ul>
    </section>
  );
});

ActionsPanel.propTypes = {
  clientId: PropTypes.string.isRequired,
  panelState: PropTypes.shape({
    policies: PropTypes.bool.isRequired,
    proposals: PropTypes.bool.isRequired,
  }).isRequired,
};

export default ActionsPanel;
